export default __webpack_public_path__ + "static/pair-icon-dark-a399c2452fa317f49a154b13c978c5c3.png";